module.exports = __webpack_public_path__ + "static/img/title.f4840c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page2/title.png
// module id = ktDX
// module chunks = 0